<template lang="pug">
div
  UiCardSection
    UiStack
      UiStackItem(fill)
        .ui-card-section-title {{ $t("companies.tabs.replacement_account_list") }}
  UiCardSection
    UiStack
      UiStackItem
        UiFileInput(
          v-model="replacementFile"
          :success="!!replacementFile"
          placeholder="Choose a file..."
          :extensions="['xlsx']"
        )
      UiStackItem
        UiButton(
          :disabled="!replacementFile"
          variant="smooth-primary"
          @click="uploadReplacementFile()"
          icon="FileUpload"
        ) {{ $t("actions.upload") }}
      UiStackItem
        UiButton(
          variant="smooth-primary"
          @click="clearReplacementFile()"
          icon="Trash"
        ) {{ $t("actions.delete") }}
  UiCardSection
    RestTable(
      namespace="replacementCodes"
      :embed="true"
      :headers="headers"
      :fetchHandler="getData"
      ref="companyReplacementListTable"
    )
</template>

<script>
import ApiCompanyAccountKeyword from "@/api/companyAccountKeyword.js";
import ApiCompanyFeatures from "@/api/companyFeatures.js";

export default {
  components: {},
  data() {
    return {
      replacementFile: null,
      headers: [
        {
          key: "old_code",
          label: "Old code",
          squeeze: false,
        },
        {
          key: "new_code",
          label: "New code",
          squeeze: false,
        },
      ],
    };
  },

  methods: {
    reloadList() {
      this.$refs.companyReplacementListTable.fetchData();
    },
    getData(params, config) {
      return ApiCompanyAccountKeyword.fetchReplacementList(
        this.$route.params.id,
        params,
        config,
      ).then((resp) => {
        return {
          items: resp.data.replacement_codes,
          meta: resp.data.meta,
        };
      });
    },
    uploadReplacementFile() {
      let formData = new FormData();
      formData.append("file", this.replacementFile);
      formData.append("company_id", this.$route.params.id);
      console.log(this.replacementFile);
      ApiCompanyFeatures.uploadReplacementFile(formData)
        .then((resp) => {
          this.reloadList();
        })
        .catch((e) => {
          this.$toaster.add({
            type: "error",
            title: this.$t("errors.operation_error"),
            message: "Can't upload replacement file",
          });
        });
    },
    clearReplacementFile() {
      let formData = new FormData();
      formData.append("company_id", this.$route.params.id);
      ApiCompanyFeatures.clearReplacementFile(formData)
        .then((resp) => {
          this.reloadList();
        })
        .catch((e) => {
          this.$toaster.add({
            type: "error",
            title: this.$t("errors.operation_error"),
            message: "Can't clear replacement file",
          });
        });
    },
  },
};
</script>
